import { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { FAQ_ITEMS } from '../data';

function FaqItem({ item }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-t border-slate-200">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex w-full cursor-pointer items-center justify-between gap-4 py-5 text-left"
      >
        <span
          className={`text-base font-semibold transition-colors ${
            isOpen ? 'text-brand-600' : 'text-slate-900'
          }`}
        >
          {item.question}
        </span>
        {isOpen ? (
          <Minus className="size-5 shrink-0 text-brand-600" aria-hidden="true" />
        ) : (
          <Plus className="size-5 shrink-0 text-slate-400" aria-hidden="true" />
        )}
      </button>
      {isOpen && (
        <div className="pb-5 pr-10">
          <p className="text-sm leading-relaxed text-slate-500">
            {item.highlightText
              ? item.answer.split(item.highlightText).map((part, index, array) =>
                  index < array.length - 1 ? (
                    <span key={index}>
                      {part}
                      <span className="font-bold text-slate-900">{item.highlightText}</span>
                    </span>
                  ) : (
                    <span key={index}>{part}</span>
                  )
                )
              : item.answer}
          </p>
        </div>
      )}
    </div>
  );
}

export function FaqSection() {
  const leftColumn = FAQ_ITEMS.filter((_, index) => index % 2 === 0);
  const rightColumn = FAQ_ITEMS.filter((_, index) => index % 2 === 1);

  return (
    <section className="bg-white">
      <div className="section-container section-y">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand-600 sm:text-sm">
          Questions Parents Ask
        </p>

        <h2 className="mt-5 max-w-2xl text-3xl font-semibold leading-[1.1] tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
          Everything you&rsquo;d want to
          <br className="hidden lg:block" />{' '}
          know before the first class.
        </h2>

        <div className="mt-12 grid gap-x-12 lg:grid-cols-2">
          <div>
            {leftColumn.map((item) => (
              <FaqItem key={item.question} item={item} />
            ))}
          </div>
          <div>
            {rightColumn.map((item) => (
              <FaqItem key={item.question} item={item} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}